import { GenericObject } from '@app/components/common/Table/DefaultTable/types';

import { DEFAULT_LANGUAGE } from './languages';

export const filterToQueryTickerCode = (searchText: string) => ({ code: `%${searchText}%` });
// export const genericfilterToQuery = (searchText: string) => ({ name: `%${searchText}%` });
export const genericfilterToQuery = (searchText: string) => {
  if (searchText.trim().length > 0) {
    return { name: `%${searchText}%` };
  }
  return undefined;
};

export const genericfilterToQueryMedia = (searchText: string) => {
  if (searchText.trim().length > 0) {
    return { title: `%${searchText}%` };
  }
  return undefined;
};

export const filterToQueryKeyword = (searchText: string) => ({
  keyword: searchText,
  language: DEFAULT_LANGUAGE,
});

export const formatFilterEmptyFields = (values: GenericObject) => {
  Object.keys(values).forEach((key: string) => {
    if (!values[key] || values[key] === '') {
      values[key] = null;
    }
  });
};
